import { useEffect, useState, useLayoutEffect } from 'react'
import { useContext } from "react";
import { ContextApp } from "../../context/ContextApp"
import { useNavigate } from "react-router-dom"
import { getFormatFecha } from '../../helpers/dates';

import Titulo from "../../components/titles/Titulo"
import Loader from '../../components/loader/Loader';
import ListVotes from '../../components/listVotes/ListVotes';

import '../pageStyles.css'
import './home.css'


const Home = () => {

  const { token, refreshToken, datos, pueblo,  } = useContext(ContextApp);
  const navigate = useNavigate();

  const [datas, setDatas] = useState()
  const [village, setVillage] = useState()
  const [villages, setVillages] = useState()
  const [votes, setVotes] = useState()

  useLayoutEffect(() => {
    (token.value === '') && navigate('/login')

    const cargar = async () => {
      await refreshToken();
      setDatas(await datos.getTotalsData())
      setVillages(await pueblo.getVillages())    
    }
    cargar();
  }, [token, datos, pueblo, refreshToken, navigate])

  useEffect(() =>{

    const InitalLoad = async () =>{
      setVillage(await villages[0].PUE_CLAVE)
    }
    villages && InitalLoad()
  }, [villages])


   useEffect(() => { 
   const loadData = async () => {
      try {
   
          setVotes(await datos.getTotalsVotes(village, token))


      } catch (error) {
        error.response.data.message === 'Votes table is empty' && setVotes(undefined)
        console.log(error.response.data.message)
      }
     }
     village && loadData()
  }, [village, datos, token])



  const onChangeSelect = (e) => {
    setVillage(e.target.value)
  }

  return (
    <div className="container-data">

      <div className='container-totals'>

        <header className='header-totals'>
          <Titulo>Datos totales</Titulo>
        </header>

        {datas ?
          <div className='body-totals'>
            <section className='section-total'>
              <h3>REGISTROS:</h3>
              <h4>· {datas.TOTAL_ARTISTAS} Artistas.</h4>
              <h4>· {datas.TOTAL_CANCIONES} Canciones.</h4>
              <h4>· {datas.TOTAL_PUEBLOS} Pueblos.</h4>
              <h4>· {datas.TOTAL_VOTOS} Votos.</h4>
            </section>
            <section className='section-data'>



              <select className="select-container select-input span"
                name="idVillage"

                onChange={onChangeSelect}
              >
                {villages && villages.map((item) => (
                  <option key={item.PUE_CLAVE} value={item.PUE_CLAVE} >
                    {item.PUE_NOMBRE}. ({getFormatFecha(item.PUE_FECACT)})
                  </option>
                ))}
              </select>

              <div className='list-data'>
                <ListVotes votes={votes} />
              </div>


            </section>
          </div>
          : <Loader />
        }
        <footer className='footer-totals'>
          <img src={require('../../assets/poptelera-linea.png')} alt='logo' />
        </footer>

      </div>
    </div>
  )
}

export default Home
